import { render } from "./ListaAccessori.vue?vue&type=template&id=1a704486"
import script from "./ListaAccessori.vue?vue&type=script&lang=js"
export * from "./ListaAccessori.vue?vue&type=script&lang=js"

import "./ListaAccessori.vue?vue&type=style&index=0&id=1a704486&lang=css"

import exportComponent from "/Users/mattia/Desktop/Projects/elbi-website-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__